import { render, staticRenderFns } from "./loginV1.vue?vue&type=template&id=d6059bfa&"
import script from "./loginV1.vue?vue&type=script&lang=js&"
export * from "./loginV1.vue?vue&type=script&lang=js&"
import style0 from "./loginV1.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports